// 测试模块
export const CHANGE_CODE = 'CHANGE_CODE' // 测试更改模块编码



// WEBPACK FOOTER //
// ./src/store/mutation-types.js